<div class="container" >
  <div class="row" >
    <div class="col-auto pl-1 m-0" *ngIf="!isValid">
      <div style="width: 5px; height: 90%;" class="eca-invalid-bg"></div>
    </div>
    <div class="col m-0 p-0">
     <div class="form-group">

        <label *ngIf="label" [for]="controlId"><strong>{{label}}</strong></label>
        <div *ngIf="!isValid && validationMessage" class="eca-invalid"><strong>{{validationMessage}}</strong></div>
        <div class="input-group">
          <!--<input pInputText [type]="inputType" class="form-control" [id]="controlId" [pattern]="pattern"
                 [ngClass]="isValid ? '': 'eca-invalid-input'"
                 [value]="value"
                 [readOnly]="isReadOnly"
                 (input)="updateValue($event.target.value)">-->

          <input pInputText [type]="inputType" class="form-control" [id]="controlId" [pattern]="pattern"
                 [ngClass]="isValid ? '': 'eca-invalid-input'"
                 [value]="value"
                 [readOnly]="isReadOnly"
                 (input)="updateValue($event.target.value)">
          <ng-template #popTemplate>
            <div *ngIf="!!popoverText" [ngClass]="isRequired ? 'required-input-guide' : 'optional-input-guide'"
                 [innerHtml]="popoverText"></div>
          </ng-template>
          <div class="input-group-append" *ngIf="popoverText">
            <app-eca-input-guide [popoverText]="popoverText" [isRequired]="isRequired" [isDisabled]="isReadOnly"></app-eca-input-guide>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
